<template>
    <div class="container-teams">
        <div class="switch-header">
            <ui-switch
                data-ui="limit-reservations-per-team"
                design="xs"
                label="Se ativado, as regras serão aplicadas imediatamente às Equipes."
                v-model="active"
                :checked="active"
                @click="enableButton = false"
            />
        </div>

        <div v-if="loading" class="container-loading">
            <ui-load-indicator bg-color="#e7e9f4" color="#3FACFF" :h="50" :stroke="8" />
        </div>

        <div v-if="active && !loading" class="container-teams-table">
            <ui-table
                not-found-icon="fa fa-file-contract"
                not-found-text="Não foi possível encontrar nenhuma Reserva para Equipes"
                name="table-teams"
                tr-component="products/permissions/reserves/components/teams/teams-table-line"
                max-height="409px"
                scroll-color="scroll-color-primary"
                line-white
                :is-fixed-list="false"
                :loading="false"
                :columns="tableColumns"
                :last-col-fixed="false"
                :select-column-menu="false"
                :data="tableData"
            />
        </div>

        <div class="button-submit">
            <div v-show="active" class="alerts">
                <em class="far fa-exclamation-triangle" />

                <span>Apenas reservas feitas por <b>Gerentes</b> e <b>Corretores</b> serão contabilizadas.</span>
            </div>

            <div class="button-end">
                <ui-button
                    data-ui="submit-reservations-per-team"
                    design="success md"
                    :disabled="enableButton"
                    @click="submit"
                >
                    <span v-if="loadingButton" class="loading-submit-teams">
                        <ui-load-indicator bg-color="#fff" color="#41A870" :h="20" :stroke="6" />
                    </span>
                    Salvar
                </ui-button>
            </div>
        </div>
    </div>
</template>

<script>
import { uiLoadIndicator, uiTable } from '@/components/ui'
import { uiButton } from '@/components/ui/buttons'
import { uiSwitch } from '@/components/ui/form'
import { alertMixin } from '@/mixins'
import { reserves } from '@/services/axios'

export default {
    name: 'ui-products-permissions-reserves-teams',

    components: {
        uiSwitch,
        uiTable,
        uiLoadIndicator,
        uiButton
    },

    props: {
        teams: {
            type: Object,
            default: () => {}
        }
    },

	mixins: [
		alertMixin
	],

    data() {
        return {
            loading: false,
            loadingButton: false,
            enableButton: true,
            type: 'teams',
            product_id: null,
            active: false,
            tableColumns: [
                { title: 'Equipes' },
                { title: 'Reservas Realizadas' },
                { title: 'Limite de Reservas' }
            ],
            tableData: [],
            configurationsData: []
        }
    },

    mounted() {
        this.product_id = this.$route.params.id
        this.loading = true

        if (this.teams.config) {
            this.tableData = this.teams.config
            this.active = this.teams.active
            this.loading = false
        } else this.loading = false

        this.$root.$on('new-limit-group-teams', payload => {
            // Verifica se já existe um item com o mesmo ID no array
            const index = this.configurationsData.findIndex(item => item.id === payload.id)
            this.enableButton = false

            if (index !== -1) {
                // Se já existe, atualiza os dados
                this.configurationsData[index] = payload
            } else {
                // Se não existe, adiciona um novo
                this.configurationsData.push(payload)
            }
        })
    },

    methods: {
        async submit() {
            this.loadingButton = true
            this.enableButton = true

            let configurations = [
                ...this.configurationsData,
                ...this.teams?.config.filter(team => !this.configurationsData.some(config => config.id === team.id))
            ].map(({ id, limit }) => ({ id, limit }))

            let data = {
                type: this.type,
                active: this.active,
                product_id: this.product_id,
                configurations: [ ...configurations ]
            }

            try {
                const response = await reserves.postConfigLimitProduct(data)
                this.$mx_alertSuccess(response.data.msg)
                this.loadingButton = false
            } catch (error) {
				if (error.data?.msg) {
					this.$mx_alertError(error.data.msg)
				} else {
					this.$mx_alertError(error)
				}
				this.loading = false
                this.loadingButton = false
                this.enableButton = false
			} finally {
				this.loading = false
                this.loadingButton = false
			}
        }
    }
}
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>